var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0.5C1.39543 0.5 0.5 1.39543 0.5 2.5V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H15.5C16.6046 17.5 17.5 16.6046 17.5 15.5V2.5C17.5 1.39543 16.6046 0.5 15.5 0.5H2.5ZM9 4.04167C6.05329 4.04167 3.46692 5.5803 2.08013 7.88243C1.97311 8.06008 1.91667 8.26254 1.91667 8.46875C1.91667 8.67496 1.97311 8.87742 2.08013 9.05507C3.46625 11.3561 6.05206 12.8958 9 12.8958C11.9467 12.8958 14.5331 11.3572 15.9199 9.0551C16.0269 8.87744 16.0833 8.67498 16.0833 8.46876C16.0833 8.26254 16.0269 8.06009 15.9199 7.88243C14.5337 5.58138 11.9479 4.04167 9 4.04167ZM12.3449 8.46875C12.3449 10.2774 10.8486 11.7409 9 11.7409C7.1511 11.7409 5.6551 10.2772 5.6551 8.46875C5.6551 6.66005 7.1514 5.19656 9 5.19656C10.8489 5.19656 12.3449 6.66033 12.3449 8.46875ZM9 10.971C7.58732 10.971 6.44213 9.85072 6.44213 8.46875C6.44213 7.08678 7.58732 5.96649 9 5.96649C9.43552 5.96649 9.84555 6.0731 10.2045 6.26089L10.2037 6.26086C9.622 6.26086 9.15045 6.72217 9.15045 7.29122C9.15045 7.86024 9.622 8.32155 10.2037 8.32155C10.7854 8.32155 11.2569 7.86027 11.2569 7.29122L11.2569 7.29045C11.4489 7.64158 11.5579 8.04269 11.5579 8.46875C11.5579 9.85072 10.4127 10.971 9 10.971Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeView);
export default __webpack_public_path__ + "static/media/EyeView.f78d618d2b20b2ecd2adc4b952bbb43a.svg";
export { ForwardRef as ReactComponent };